import { useLink } from '../../../shared/link';
import { useEnv } from '../../../shared/utils/env';
import { extractAgencyFromUrl } from '../../../shared/utils/url';

const env = useEnv({ shortened: true });
const agency = extractAgencyFromUrl(window.location.hostname) || undefined;

export const ordersRedirect = (token, { hasAnalytics } = { hasAnalytics: false }) => {
  const link = useLink({
    product: hasAnalytics ? 'analytics' : 'compulse360',
    env,
    agency,
  });
  window.location.href = `${link}/ahlogin?token=${token}&redirectUri=${link}/orders`;
};
